<template>
  <br>
  <h2 v-show="this.$parent.current!=null">Рецепт крафта: {{this.$parent.getTitle(this.$parent.current).toLowerCase()}}</h2>
  <span v-show="this.$parent.current!=null">
    Для создания блока "{{this.$parent.getTitle(this.$parent.current)}}" используются следующие ингридиенты: 
    <i :set="items = unicalize(this.$parent.current_items)">
      <template v-for="(s, v, index) in items" :key="s">
              {{this.$parent.getTitle(this.$parent.getItem(s)).toLowerCase()}}<template v-if="index < Object.keys(items).length -1">, </template>
      </template>
    </i>. <br>Расположите ингридиенты 
    <template v-if="this.$parent.current_items.length == 9">на верстаке</template>
    <template v-if="this.$parent.current_items.length == 3">в варочной стойке</template>
    <template v-if="this.$parent.current_items.length == 2 && this.$parent.current_type==0">в печи</template>
    <template v-if="this.$parent.current_items.length == 1">на камнерезе</template>
    <template v-if="this.$parent.current_type==1">на кузнечном столе</template>, как указано на схеме.
  </span>
</template>

<script>
export default {
  name: 'MineCraftDescription',
  data() {
    return {
  }},
  methods: {
    unicalize(k){
      let s = {}
      k.forEach(element => {
        if (element!= "")
        s[element] = element;
      });
      return s
    }
  }
}
</script>


